// extracted by mini-css-extract-plugin
module.exports = {"list":"list-module--list--3QqBf","listItem":"list-module--list-item--2EWDb"};